import { all, call } from "redux-saga/effects";
import onCreateExam from "./createExam";
import onDeleteExam from "./deleteExam";
import onEditExam from "./editExam";
import onGetAllExam from "./getAllExams";
import onGetExam from "./getExam";

export default function* examSagas() {
  yield all([
    call(onGetAllExam),
    call(onCreateExam),
    call(onGetExam),
    call(onEditExam),
    call(onDeleteExam),
  ]);
}
